import React from 'react';
import { Field } from 'redux-form';
import { Checkbox, TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import Filters from '../../../components/Filters';

export default ({ handleFilter, handleResetFilter, filterValues }) => {
  const fieldMap = {
    email: 'Email',
    name: 'Name',
    status: 'Status',
    hasStartedJobs: 'Has Started Jobs',
    hasOpenJobOffers: 'Has Open Job Offers',
    hasDocuments: 'Has Documents',
  };

  return (
    <Filters
      handleFilter={handleFilter}
      handleResetFilter={handleResetFilter}
      fieldMap={fieldMap}
      values={filterValues}
    >
      <Field name="email" floatingLabelText="Email" component={TextField} />
      <br />
      <Field name="name" floatingLabelText="Name" component={TextField} />
      <br />
      <Field name="status" floatingLabelText="Status" component={SelectField}>
        <MenuItem value="" primaryText="" />
        <MenuItem value="Active" primaryText="Active" />
        <MenuItem value="Pending" primaryText="Pending" />
        <MenuItem value="Locked" primaryText="Locked" />
      </Field>
      <br />
      <Field
        name="hasStartedJobs"
        label="Has Started Jobs"
        component={Checkbox}
      />
      <Field
        name="hasOpenJobOffers"
        label="Has Open Job Offers"
        component={Checkbox}
      />
      <Field name="hasDocuments" label="Has Documents" component={Checkbox} />
    </Filters>
  );
};



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorsFilter.js